var map = {
	"./and.svg": "e5a7",
	"./array.svg": "8bfb",
	"./buffer.svg": "6942",
	"./concatenation.svg": "c413",
	"./constant.svg": "ff7f",
	"./control.svg": "583f",
	"./control3.svg": "3dc3",
	"./inv.svg": "774a",
	"./led.svg": "7fe1",
	"./ledbar.svg": "10b7",
	"./leds.svg": "6871",
	"./memory.svg": "1f51",
	"./mux.svg": "7c43",
	"./nand.svg": "2214",
	"./nor.svg": "bdbe",
	"./not.svg": "b938",
	"./number.svg": "eee9",
	"./or.svg": "ae8a",
	"./portbuffer.svg": "b17b",
	"./reg.svg": "5180",
	"./response.svg": "68a0",
	"./sevenseg.svg": "3f2f",
	"./splitter.svg": "bb25",
	"./wiregate.svg": "54ae",
	"./xor.svg": "96f2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";